var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearchHeatmap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.498047,
    y: 8.25781,
    width: 18,
    height: 19,
    transform: "rotate(-18.059 0.498047 8.25781)",
    fill: "#FFE3DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7H12V11H8V7ZM6 13V5H14V13H6ZM18 7H22V11H18V7ZM16 13V5H24V13H16ZM12 17H8V21H12V17ZM6 15V23H14V15H6ZM18 17H22V21H18V17ZM16 23V15H24V23H16Z",
    fill: "#ED6A5A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearchHeatmap);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;